<script>
    export let title = "title";

    export let imageLink = "https://via.placeholder.com/150";
    export let price = 0;
    export let priceFormatted = new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(price);
    export let description = "description";
    export let isPaid = true;
</script>

<div class="card">
    <div class="card-header">
        <div class="card-title">
            <div class="title">{title}</div>
        </div>
    </div>
    <div class="card-content">
        <div class="overlay" style={isPaid ? "display: flex" : "display: none"}>
            <div class="paid">PAID</div>
        </div>
        <div class="card-img">
            <!-- svelte-ignore a11y-img-redundant-alt -->
            <img src={imageLink} alt="card-image" />
        </div>

        <div class="price">{priceFormatted}</div>
        <div class="card-content-text">{description}</div>
    </div>
</div>

<style>
    .card {
        @apply bg-surface-100 border-surface-300 w-full h-full;
        border-radius: 20px;
        display: flex;
        flex-direction: column;
        min-width: 220px;
        min-height: 100%;
        justify-content: space-between;
        align-items: center;
        margin: auto;
        box-shadow: 0px 0px 30px 0px #00000026;

        /* flex-grow: 1 !important; */
    }

    .overlay {
        position: relative;
        z-index: 1;
        top: 130px;
        rotate: -10deg;
        opacity: 0.8;
        font-size: 200px;
        left: 0;
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .paid {
        @apply text-center;
        color: #f3a719e0;

        font-size: 46px;
        font-weight: 900;
    }

    .card-header {
        @apply w-full;
    }

    .card-title {
        @apply w-full;
    }

    .title {
        @apply font-semibold text-center;
        font-size: 150% /* 30px */;
        /* shrink text if it's too long */

        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        line-height: 2.25rem /* 36px */;
        margin: 0 0 0.5rem 0;
        padding: 0 0 0.5rem 0;

        line-height: 3rem;

        border-bottom: 1px solid black;
    }

    .card-content {
        @apply w-full;
    }

    .card-img {
        @apply w-full;
        display: flex;
        max-height: 100px;
        padding: 0 1rem;
        justify-content: center;
    }

    .card-img img {
        @apply w-full;
        max-height: 100px;
        justify-content: center;
        object-fit: cover;
        margin: auto;
    }

    .card-content-text {
        @apply text-lg;
        padding: 0 1rem;
        margin: 1rem 0;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        text-align: center;
        line-height: 2rem;
    }

    .price {
        @apply text-3xl font-semibold text-center;
        line-height: 1rem;
        margin: 2.5rem 0 1rem 0;
        /* padding: 1rem 0rem; */
    }
</style>
